import { Component, OnInit } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { DashboardDeviceService } from 'src/app/services/dashboard-services/dashboard-device-service/dashboard-device.service';
import { DashboardDeviceStatus } from 'src/app/models/dashboard-models/dasboard-device-status.model';
import { DashboardCenter } from 'src/app/models/dashboard-models/dasboard-center.model';

@Component({
  selector: 'app-dashboard-devices',
  templateUrl: './dashboard-devices.component.html',
  styleUrls: ['./dashboard-devices.component.scss']
})
export class DashboardDevicesComponent implements OnInit {

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  centers: Array<DashboardCenter>;
  devices: Array<DashboardDeviceStatus>;
  devicesStatus;
  connectivityData;
  noItemsConfig;
  getDevicesSubscription: Subscription;
  getCentersSubscription: Subscription;

  constructor(
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private dashboardDeviceService: DashboardDeviceService,
    private snackbarService: SnackBarService) {
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCenters();
    this.getCenterDevicesByStatus();
  }

  private getCenters() {
    this.getCentersSubscription = this.dashboardDeviceService.getCenters().pipe(
      tap(o => this.centers = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getCenterDevicesByStatus() {
    this.getDevicesSubscription = this.dashboardDeviceService.getDevicesByStatus().pipe(
      tap(o => this.devices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.dashboard devices'));
  }

  private setNoItemsConfig() {
    return {
      description: 'dashboard-page.selected centers not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

}
